import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=0cc5d7c0&scoped=true&"
import script from "./disclaimer.vue?vue&type=script&lang=js&"
export * from "./disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer.vue?vue&type=style&index=0&id=0cc5d7c0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc5d7c0",
  null
  
)

component.options.__file = "disclaimer.vue"
export default component.exports